export default {
  settings: {
    // TODO: Translate (PWA)
    changeSettingsPasscode: 'Cambiar el código de acceso de la configuración',
    chooseDefaultSurvey: 'Elija la encuesta predeterminada',
    congratulations: '¡Enhorabuena!',
    downloadSurveys: 'Descarga la última configuración de la encuesta',
    heading: 'Configuración',
    lastSynchronised: 'Última sincronización del dispositivo: {n}',
    // not in use
    lastUploaded: 'Últimas encuestas cargadas en el dispositivo: {n}',
    // not in use
    manageTeam: 'Gestionar equipo',
    never: 'Nunca',
    resetConfirmation: '¿Está seguro(a) de que desea restablecer este dispositivo?',
    resetDevice: 'Restablecer el dispositivo',
    resetError: 'No hemos podido dar de baja vuestro dispositivo. Esto tendrá que hacerse manualmente a través del back office.',
    resetSuccess: 'Hemos restablecido con éxito vuestro dispositivo.',
    resetWait: 'Por favor, espere mientras restablecemos vuestro  dispositivo',
    surveysDownloaded: 'La última configuración de la encuesta se ha descargado con éxito.',
    surveysDownloadError: 'No pudimos descargar la configuración de la encuesta.',
    surveysDownloading: 'Por favor, espere mientras descargamos la última configuración de la encuesta',
    surveysUploaded: 'Not Implemented.',
    surveysUploadError: 'Not Implemented.',
    surveysUploadErrorTitle: 'Not Implemented.',
    surveysUploading: 'Por favor, espere mientras cargamos las encuestas completadas',
    surveyUploadedCount: 'Not Implemented.',
    uploadSurveys: 'Not Implemented.',
    updateApp: 'Not Implemented.',
    appUpdating: 'Not Implemented.',
    appUpdated: 'Not Implemented.',
    updateAvailable: 'Not Implemented.',
    menuInsights: {
      download: 'Descargar productos',
      downloading: 'Por favor espera mientras descargamos tus productos',
      complete: '¡Felicidades! Los últimos productos se han descargado exitosamente',
      error: 'No pudimos descargar los últimos productos'
    },
    isStandAlone: 'Es autónomo: ',
    isAPK: 'Es APK: ',
    pwaStatuses: 'PWA Estados',
    pwaMode: 'Está funcionando como: ',
    pwaModes: {
      apk: 'Instalado APK',
      pwa: 'Instalado PWA',
      web: 'Navegador web'
    },
    yes: 'Sì',
    no: 'No'
  }
};